import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
const Login = resolve => require(["@/components/Login"], resolve);
const SignUp = resolve => require(["@/components/SignUp"], resolve);
const ForgetPassword = resolve =>
  require(["@/components/ForgetPassword.vue"], resolve);
const CheckPhone = resolve =>
  require(["@/components/signUp/CheckPhone"], resolve);
const InputInfo = resolve =>
  require(["@/components/signUp/InputInfo"], resolve);
const SignUpDone = resolve =>
  require(["@/components/signUp/SignUpDone"], resolve);
const GoodsList = resolve => require(["@/components/GoodsList"], resolve);
const GoodsDetail = resolve => require(["@/components/GoodsDetail"], resolve);
const ShoppingCart = resolve => require(["@/components/ShoppingCart"], resolve);
const Order = resolve => require(["@/components/Order"], resolve);
const Pay = resolve => require(["@/components/Pay"], resolve);
const PayDone = resolve => require(["@/components/PayDone"], resolve);
const Freeback = resolve => require(["@/components/Freeback"], resolve);
const Home = resolve => require(["@/components/Home"], resolve);
const MyAddress = resolve => require(["@/components/home/MyAddress"], resolve);
const AddAddress = resolve =>
  require(["@/components/home/AddAddress"], resolve);
const MyOrder = resolve => require(["@/components/home/MyOrder"], resolve);
const MyShoppingCart = resolve =>
  require(["@/components/home/MyShoppingCart"], resolve);
const Merchant = resolve => require(["@/components/Merchant"], resolve);
const NoLogin = resolve => require(["@/components/popup/NoLogin"], resolve);
const IndexPopup = resolve =>
  require(["@/components/popup/IndexPopup"], resolve);
const Collect = resolve => require(["@/components/popup/Collect"], resolve);
const DeleteCart = resolve =>
  require(["@/components/popup/DeleteCart"], resolve);
const NoCollect = resolve => require(["@/components/popup/NoCollect"], resolve);
const ListClassify = resolve =>
  require(["@/components/nav/ListClassify"], resolve);
const RightFlex = resolve => require(["@/components/nav/RightFlex"], resolve);
const BackTop = resolve => require(["@/components/nav/BackTop"], resolve);
const ShopCart = resolve => require(["@/components/cart/ShopCart"], resolve);
const MyCart = resolve => require(["@/components/cart/MyCart"], resolve);
const CheckOder = resolve => require(["@/components/cart/CheckOder"], resolve);
const PayOder = resolve => require(["@/components/cart/PayOder"], resolve);
const CompletePay = resolve =>
  require(["@/components/cart/CompletePay"], resolve);
const ChineseMedicineZone = resolve =>
  require(["@/components/specialZone/ChineseMedicineZone"], resolve);
const ClinicZone = resolve =>
  require(["@/components/specialZone/ClinicZone"], resolve);
const BrandZone = resolve =>
  require(["@/components/specialZone/BrandZone"], resolve);
const PublicZone = resolve =>
  require(["@/components/specialZone/PublicZone"], resolve);
const NewCoupons = resolve =>
  require(["@/components/specialZone/NewCoupons"], resolve);
const NewSpecialOffer = resolve =>
  require(["@/components/specialZone/NewSpecialOffer"], resolve);
const EmptyPage = resolve =>
  require(["@/components/public/EmptyPage"], resolve);
const ApparatusZone = resolve =>
  require(["@/components/specialZone/ApparatusZone"], resolve);
const DailyZone = resolve =>
  require(["@/components/specialZone/DailyZone"], resolve);
const BrandList = resolve =>
  require(["@/components/specialZone/BrandList"], resolve);
const BrandShow = resolve => require(["@/components/specialZone/BrandShow"], resolve);
const ControlPinZone = resolve => require(["@/components/specialZone/ControlPinZone"], resolve);
const ValidityPeriodZone = resolve => require(["@/components/specialZone/ValidityPeriodZone"], resolve);
const SubsidyZone = resolve => require(["@/components/specialZone/SubsidyZone"], resolve);
const ScrabbleDoughZone = resolve => require(["@/components/specialZone/ScrabbleDoughZone"], resolve);
//const Personal = resolve => require(['@/components/personal/Personal'], resolve);
Vue.use(Router);

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    //vue中使用vue-router切换页面时滚动条自动滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/", // 首页
      name: "Index",
      component: Index,
      meta: { isAllowNoLogin: true }
    },
    {
      path: "/Login", // 登录
      name: "Login",
      component: Login,
      meta: { isAllowNoLogin: true }
    },
    {
      path: "/ForgetPassword", // 忘记密码
      name: "ForgetPassword",
      component: ForgetPassword,
      meta: { isAllowNoLogin: true }
    },
    {
      path: "/SignUp", // 注册
      name: "SignUp",
      component: SignUp,
      meta: { isAllowNoLogin: true },
      children: [
        {
          path: "/",
          name: "index",
          component: CheckPhone,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "checkPhone",
          name: "CheckPhone",
          component: CheckPhone,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "inputInfo",
          name: "InputInfo",
          component: InputInfo,
          meta: { isAllowNoLogin: true }
        },
        {
          path: "signUpDone",
          name: "SignUpDone",
          component: SignUpDone,
          meta: { isAllowNoLogin: true }
        }
      ]
    },
    {
      path: "/ShopCart", // 购物车结算
      name: "ShopCart",
      component: ShopCart,
      children: [
        {
          path: "/",
          name: "index",
          component: MyCart
        },
        {
          path: "MyCart",
          name: "MyCart",
          component: MyCart
        },
        {
          path: "CheckOder",
          name: "CheckOder",
          component: CheckOder
        },
        {
          path: "PayOder",
          name: "PayOder",
          component: PayOder
        },
        {
          path: "CompletePay",
          name: "CompletePay",
          component: CompletePay
        }
      ]
    },
    {
      path: "/DeleteCart", // 删除购物车商品
      name: "DeleteCart",
      component: DeleteCart
    },
    {
      path: "/GoodsList", // 商品列表
      name: "GoodsList",
      component: GoodsList
      /* meta:{requireAuth},*/
    },
    {
      path: "/NoLogin", // 未登录弹出框
      name: "NoLogin",
      component: NoLogin
    },
    {
      path: "/IndexPopup", // 首页弹出框
      name: "IndexPopup",
      component: IndexPopup
    },
    {
      path: "/Collect", // 收藏弹出框
      name: "Collect",
      component: Collect
    },
    {
      path: "/NoCollect", // 取消收藏弹出框
      name: "NoCollect",
      component: NoCollect
    },
    {
      path: "/ListClassify", // 列表药理分类
      name: "ListClassify",
      component: ListClassify
    },
    {
      path: "/RightFlex", // 右侧悬浮框
      name: "RightFlex",
      component: RightFlex
    },
    {
      path: "/BackTop", // 返回顶部按钮
      name: "BackTop",
      component: BackTop
    },
    {
      path: "/goodsDetail", // 商品详情
      name: "GoodsDetail",
      component: GoodsDetail
    },
    {
      path: "/shoppingCart", // 商品详情
      name: "ShoppingCart",
      component: ShoppingCart
    },
    {
      path: "/order", // 订单页面
      name: "Order",
      component: Order
    },
    {
      path: "/pay", // 支付页面
      name: "Pay",
      component: Pay
    },
    {
      path: "/payDone", // 支付成功页面
      name: "PayDone",
      component: PayDone
    },
    {
      path: "/freeback", // 反馈页面
      name: "Freeback",
      component: Freeback
    },
    {
      path: "/home", // 主页
      name: "Home",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomeIndex",
          component: MyOrder
        },
        {
          path: "myAddress",
          name: "MyAddress",
          component: MyAddress
        },
        {
          path: "addAddress",
          name: "AddAddress",
          component: AddAddress
        },
        {
          path: "myOrder",
          name: "MyOrder",
          component: MyOrder
        },
        {
          path: "myShoppingCart",
          name: "MyShoppingCart",
          component: MyShoppingCart
        }
      ]
    },
    {
      path: "/merchant",
      name: "Merchant",
      component: Merchant
    },
    {
      path: "/personal", // 个人中心首页
      name: "/personal",
      component: () => import("@/components/personal/Personal.vue"),

      children: [
        {
          path: "Site", //收货地址
          name: "Site",
          component: () => import("@/components/personal/Site.vue")
        },
        {
          path: "Coupon", //优惠劵
          name: "Coupon",
          meta: {
            title: "优惠券管理"
          },
          component: () => import("@/components/personal/Coupon.vue")
        },
        {
          path: "Balance", //余额管理
          name: "Balance",
          component: () => import("@/components/personal/Balance.vue")
        },
        {
          path: "RedPacket", //红包余额
          name: "RedPacket",
          component: () => import("@/components/personal/RedPacket.vue")
        },
        {
          path: "/Withdraw", //余额管理去提现
          name: "Withdraw",
          component: () => import("@/components/personal/Withdraw.vue")
        },
        {
          path: "Rightpersonal", //个人中心
          name: "Rightpersonal",
          component: () => import("@/components/personal/Rightpersonal.vue")
        },
        {
          path: "Basic", //基本信息
          name: "Basic",
          component: () => import("@/components/personal/Basic.vue")
        },
        {
          path: "license", //基本信息
          name: "license",
          component: () => import("@/components/personal/License.vue")
        },
        {
          path: "Favorites", //我的收藏
          name: "Favorites",
          component: () => import("@/components/personal/Favorites.vue")
        },
        {
          path: "Purchase", //智能采购
          name: "Purchase",
          component: () => import("@/components/personal/Purchase.vue")
        },
        {
          path: "Member", //多会员管理
          name: "Member",
          component: () => import("@/components/personal/Member.vue")
        },
        {
          path: "/Unbound", //多会员管理-未绑定手机号
          name: "Unbound",
          component: () => import("@/components/personal/Unbound.vue")
        },
        {
          path: "MyMessages", //我的消息
          name: "MyMessages",
          component: () => import("@/components/personal/MyMessages.vue")
        },
        {
          path: "MyRequest", //我的求购
          name: "MyRequest",
          component: () => import("@/components/personal/MyRequest.vue")
        },

        {
          path: "MyFeedback", //我的反馈
          name: "MyFeedback",
          component: () => import("@/components/personal/MyFeedback.vue")
        },

        {
          path: "MyOrder", //我的订单
          name: "MyOrder",
          component: () => import("@/components/personal/MyOrder.vue")
        },
        {
          path: "/OrderDetails", //订单详情
          name: "OrderDetails",
          component: () => import("@/components/personal/OrderDetails.vue")
        },
        {
          path: "UserFeedback", //用户反馈
          name: "UserFeedback",
          component: () => import("@/components/personal/UserFeedback.vue")
        },
        {
          path: "Details", //用户反馈
          name: "Details",
          component: () => import("@/components/personal/Details.vue")
        }
      ]
    },
    {
      path: "/BuyingArea", //求购专区
      name: "BuyingArea",
      component: () => import("@/components/personal/BuyingArea.vue")
    },
    {
      path: "/PointsMall", //积分商城
      name: "PointsMall",
      component: () => import("@/components/pointsmall/PointsMall.vue")
    },
    {
      path: "/Sign", //签到
      name: "Sign",
      component: () => import("@/components/pointsmall/Sign.vue")
    },
    {
      path: "/PointsIndividual", //积分商城个人中心
      name: "PointsIndividual",
      component: () => import("@/components/pointsmall/PointsIndividual.vue"),
      children: [
        {
          path: "MyScores", //我的积分
          name: "MyScores",
          component: () => import("@/components/pointsmall/MyScores.vue")
        },
        {
          path: "PointsOrder", //积分订单
          name: "PointsOrder",
          component: () => import("@/components/pointsmall/PointsOrder.vue")
        },
        {
          path: "Address", //我的地址
          name: "Address",
          component: () => import("@/components/pointsmall/Address.vue")
        }
      ]
    },

    {
      path: "/Lottery", //抽奖页面
      name: "Lottery",
      component: () => import("@/components/lottery/Lottery.vue")
    },
    {
      path: "/ShoppingCartPage", //购物车页面
      name: "ShoppingCartPage",
      component: () => import("@/components/pointsmall/ShoppingCartPage.vue")
    },
    {
      path: "/ProductDetails", //积分商品详情
      name: "ProductDetails",
      component: () => import("@/components/pointsmall/ProductDetails.vue")
    },
    {
      path: "/IntegralSettlement", //积分结算页面
      name: "IntegralSettlement",
      component: () => import("@/components/pointsmall/IntegralSettlement.vue")
    },
    {
      path: "/ShoppingCartPage", //购物车页面
      name: "ShoppingCartPage",
      component: () => import("@/components/pointsmall/ShoppingCartPage.vue")
    },
    {
      path: "/ProductDetails", //积分商品详情
      name: "ProductDetails",
      component: () => import("@/components/pointsmall/ProductDetails.vue")
    },
    {
      path: "/IntegralSettlement", //积分结算页面
      name: "IntegralSettlement",
      component: () => import("@/components/pointsmall/IntegralSettlement.vue")
    },
    {
      path: "/ChineseMedicineZone", // 中药专区页面
      name: "ChineseMedicineZone",
      component: ChineseMedicineZone
    },
    {
      path: "/ClinicZone", // 诊所专区页面
      name: "ClinicZone",
      component: ClinicZone
    },
    {
      path: "/ApparatusZone", // 器械专区页面
      name: "ApparatusZone",
      component: ApparatusZone
    },
    {
      path: "/DailyZone", // 日化专区页面
      name: "DailyZone",
      component: DailyZone
    },
    {
      path: "/BrandZone", // 品牌专区页面
      name: "BrandZone",
      component: BrandZone
    },
    {
      path: "/BrandList", // 品牌单独列表页面
      name: "BrandList",
      component: BrandList
    },
    {
      path: "/PublicZone", // banner+列表模式专区页面
      name: "PublicZone",
      component: PublicZone
    },

    {
      path: "/Promotion", //促销专区页面
      name: "Promotion",
      component: () => import("@/components/specialZone/Promotion.vue")
    },
    {
      path: "/WeeklyList", //促销专区-每周特价列表
      name: "WeeklyList",
      component: () => import("@/components/specialZone/WeeklyList.vue")
    },
    {
      path: "/BoutiqueList", //促销专区-买赠列表
      name: "BoutiqueList",
      component: () => import("@/components/specialZone/BoutiqueList.vue")
    },
    {
      path: "/SwapList", //促销专区-换购列表
      name: "SwapList",
      component: () => import("@/components/specialZone/SwapList.vue")
    },

    {
      path: "/Seckill", //秒杀专区页面
      name: "Seckill",
      component: () => import("@/components/specialZone/Seckill.vue")
    },
    {
      path: "/GoodsCombo", //商品套餐
      name: "GoodsCombo",
      component: () => import("@/components/GoodsCombo.vue")
    }
    ,
    {
      path: "/ComPackageZone", //商品套餐列表
      name: "ComPackageZone",
      component: () => import("@/components/specialZone/ComPackageZone.vue")
    },

    {
      path: "/NewCoupons", // 新人优惠券专区页面
      name: "NewCoupons",
      component: NewCoupons
    },
    {
      path: "/NewSpecialOffer", // 新人特价专区页面
      name: "NewSpecialOffer",
      component: NewSpecialOffer
    },
    {
      path: "/Receive", //秒杀专区页面
      name: "Receive",
      component: () => import("@/components/specialZone/Receive.vue")
    },
    {
      path: "/EmptyPage", //搜索为空专区页面
      name: "EmptyPage",
      component: EmptyPage
    },
    {
      path: "/Helps", //帮助中心
      name: "helpss",
      component: () => import("@/components/helpss/Helps.vue"),
      children: [
        {
          path: "HelpLogin", //免费注册
          name: "HelpLogin",
          component: () => import("@/components/helpss/HelpLogin.vue")
        },
        {
          path: "Buy", //安全购药
          name: "Buy",
          component: () => import("@/components/helpss/Buy.vue")
        },
        {
          path: "Qualification", //安全购药
          name: "qualification",
          component: () => import("@/components/helpss/Qualification.vue")
        },
        {
          path: "Courier", //安全购药
          name: "Courier",
          component: () => import("@/components/helpss/Courier.vue")
        },
        {
          path: "Pay", //订单支付
          name: "Pay",
          component: () => import("@/components/helpss/Pay.vue")
        },
        {
          path: "Refund", //药瓶退换
          name: "Refund",
          component: () => import("@/components/helpss/Refund.vue")
        },
        {
          path: "OnLine", //订单支付
          name: "OnLine",
          component: () => import("@/components/helpss/OnLine.vue")
        },
        {
          path: "Contact", //联系我们
          name: "Contact",
          component: () => import("@/components/helpss/Contact.vue")
        },
        {
          path: "Company", //公司简介
          name: "Company",
          component: () => import("@/components/helpss/Company.vue")
        },
        {
          path: "User", //用户协议
          name: "User",
          component: () => import("@/components/helpss/User.vue")
        },
        {
          path: "Service", //服务
          name: "Service",
          component: () => import("@/components/helpss/Service.vue")
        },
        {
          path: "Mass", //服务
          name: "Mass",
          component: () => import("@/components/helpss/Mass.vue")
        }
      ]
    },
    {
      path: "/News", //新闻中心页面
      name: "News",
      component: () => import("@/components/News/News.vue"),
      children:[
        {
          path: "NewsList", //新闻列表
          name: "NewsList",
          component: () => import("@/components/News/NewsList.vue")
        },
        {
          path: "NewsDetails", //新闻列表
          name: "NewsDetails",
          component: () => import("@/components/News/NewsDetails.vue")
        }
      ]
    },
    {
      path: "/BrandShow", // 新增-品牌专场页面
      name: "BrandShow",
      component: BrandShow
    },
    {
      path: "/ControlPinZone", // 新增-控销专区
      name: "ControlPinZone",
      component: ControlPinZone
    },
    {
      path: "/ValidityPeriodZone", // 新增-效期专区
      name: "ValidityPeriodZone",
      component: ValidityPeriodZone
    },
    {
      path: "/SubsidyZone", // 新增-诊所精选
      name: "SubsidyZone",
      component: SubsidyZone
    },
    {
      path: "/ScrabbleDoughZone", // 新增-拼团专区
      name: "ScrabbleDoughZone",
      component: ScrabbleDoughZone
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js